import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import MasterListPage from "./MasterListPage";
import ActionDropdown from "Common/ActionDropdown/ActionDropdown";
// import { fetchSalesOrders, exportSalesOrdersCSV } from "slices/salesorder/thunk";
// import PersonAddIcon from "@mui/icons-material/PersonAdd";
import {
  fetchIssuePackingSalesOrderStatusUpdate,
  fetchSalesOrderStatusUpdate,
} from "slices/sales_order/thunk";
import { useDispatch } from "react-redux";
import StatusDropdown from "Common/Components/StatusDropdown/statusDropdown";
import { salesOrderStatusOptions } from "Common/Components/StatusDropdown/statusOptions";
import {
  handleProductSalesOrderStatus,
  handleServiceSalesOrderStatus,
  handleRevertProductSalesOrderStatus,
  handleProductGeneratePISalesOrder,
  downloadSalesOrderPdf,
  handleProductDownloadAcknowledgementSalesOrder,
} from "slices/sales_order/thunk";
import { DynamicMenuItem } from "Common/Components/DynamicActionMenu/DynamicActionMenu";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import DescriptionIcon from "@mui/icons-material/Description";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import UndoIcon from "@mui/icons-material/Undo";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import NameWithDate from "Common/Components/NameWithDate.tsx/NameWithDate";
import FormattedDate from "Common/Components/NameWithDate.tsx/FormattedDate";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import { formatIndianAmount } from "helpers/formatIndianAmount";
import {
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button as MuiButton,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Chip from "components/Chips/Chip";
import StatusChip from "pages/Enquiry/Components/StatusChip";
import { toast } from "react-toastify";
import { showConfirm, showError, showInfo, showSuccess, showLoading, hideLoading } from "helpers/swalHelper";
import { MecordColors } from "Constants/Color";
import { autocompleteDropdownStyles } from "Constants/Style";
import BootstrapTextField from "Common/Components/InputComponent/BootstrapTextField";
import { Axios } from "api/axios";
import FollowUpPopUp from "components/FollowUpModal/FollowUpPopUp";
import FollowupModel from "components/FollowUpModal/FollowUpModel";
import {
  QUOTATION_TYPE,
  SALES_ORDER_CATEGORY,
  SALES_ORDER_TYPE,
} from "Constants/StatusConstant";
import { app_modules } from "helpers/apps_modules_list";
import usePermission from "hooks/usePermission";
import Tooltip from "@mui/material/Tooltip";

interface SalesOrderPageProps {
  type?: "product"; // Product specific, defaults to product
}

// Helper function to strip HTML tags from text
const stripHtmlTags = (html: string | null | undefined): string => {
  if (!html) return "-";
  // Remove HTML tags using regex
  const textContent = html.replace(/<[^>]*>/g, "");
  // Decode HTML entities
  const tmp = document.createElement("div");
  tmp.innerHTML = textContent;
  const decodedText = tmp.textContent || tmp.innerText || textContent;
  // Trim whitespace and return, or "N/A" if empty
  return decodedText.trim() || "-";
};

const SalesOrderLog: React.FC<SalesOrderPageProps> = ({ type = "product" }) => {
  const { tab } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const activeType = "product"; // Hardcoded for product
  const activeTab = tab;
  document.title = "Sales Order"
  // Get permissions for product sales orders
  const { canView, canCreate, canUpdate, canDelete } = usePermission(
    app_modules?.sales_order?.app_name,
    app_modules?.sales_order?.modules?.product
  );

  // Warehouse modal state
  const [showWarehouseModal, setShowWarehouseModal] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState<any>(null);
  const [warehouseOptions, setWarehouseOptions] = useState<any[]>([]);
  const [selectedSalesOrderId, setSelectedSalesOrderId] = useState<string>("");
  const [loadingWarehouses, setLoadingWarehouses] = useState(false);
  const [reloadFlag, setReloadFlag] = useState(0);
  // Follow Up Modal  states
  const [showFollowUpModal, setShowFollowUpModal] = useState(false);
  const [selectedFollowUpItem, setSelectedFollowUpItem] = useState<any>(null);

  // Fetch warehouses on component mount
  useEffect(() => {
    const fetchWarehouses = async () => {
      try {
        setLoadingWarehouses(true);
        const response = await Axios.get(
          API_ENDPOINT.MASTERS.WAREHOUSE.DROPDOWN
        );
        setWarehouseOptions(response.data?.data || []);
      } catch (error) {
        console.error("Failed to fetch warehouses:", error);
        toast.error("Failed to load warehouses");
      } finally {
        setLoadingWarehouses(false);
      }
    };

    fetchWarehouses();
  }, []);

  // dynamic title
  const title =
    activeTab === "sales_order_log"
      ? "Order Log"
      : activeTab === "junk"
        ? "Junk"
        : "Draft";

  // dynamic add label
  const addButtonLabel = "Create Sales Order";

  // dynamic add route
  const addRoute = `/sales_order/add_product_sales_order`;

  const handleView = (salesOrderNo: any) => {
    // redirect to single sales order page
    navigate(`/sales_order/${activeType}/${activeTab}/view/${salesOrderNo.sales_order_product_id || salesOrderNo.sales_order_service_id || salesOrderNo.id}`);
  };

  const handleEdit = (salesOrderNo: any) => {
    // redirect to edit form
    navigate(`/sales_order/${activeType}/edit/${salesOrderNo.sales_order_product_id || salesOrderNo.sales_order_service_id || salesOrderNo.id}`, {
      state: { tab: activeTab }
    });
  };

  const handleRevert = async (salesOrderNo: any) => {
    const result = await showConfirm(
      "Are you sure you want to revert this sales order?",
      "Revert Sales Order",
      "Yes, Revert",
      "Cancel"
    );

    if (result.isConfirmed) {
      try {
        await dispatch(handleRevertProductSalesOrderStatus(salesOrderNo?.sales_order_product_id || salesOrderNo?.sales_order_service_id || salesOrderNo?.id)).unwrap();
        toast.success("Sales order reverted successfully");
        // Trigger refresh by incrementing reloadFlag
        setReloadFlag(prev => prev + 1);
      } catch (error: any) {
        toast.error(error?.message || "Failed to revert sales order");
      }
    }
  };

  // const handleConvertJunk = async (enquiryId: string) => {
  //   try {
  //     const resData =
  //       activeType === "product"
  //         ? await dispatch(
  //             handleProductSalesOrderStatus({
  //               id: enquiryId,
  //               sales_order_stage: "junk",
  //             })
  //           ).unwrap()
  //         : await dispatch(
  //             handleServiceSalesOrderStatus({
  //               id: enquiryId,
  //               sales_order_stage: "junk",
  //             })
  //           ).unwrap();
  //     if (resData) {
  //       // toast.success("Enquiry moved to junk successfully")
  //       navigate(`/sales_order/${activeType}/junk`);
  //     }
  //   } catch (err) {
  //     console.error("Error converting to junk:", err);
  //   }
  // };

  // const handleRestore = (salesOrderNo: string) => {
  //   // dispatch(restoreSalesOrder(salesOrderNo))
  // };

  const handleFollowUp = (salesOrderNo: string) => {
    // redirect to follow up form
    navigate(`/sales_order/followups/${activeType}/${salesOrderNo}`);
  };
  // const handleCreateSalesOrder = (salesOrderNo: string) => {
  //   // redirect to create sales order form
  //   navigate(`/sales-order/${activeType}/create-from-enquiry/${salesOrderNo}`);
  // };

  const handleIssuePacking = (salesOrderNo: any) => {
    // Show warehouse selection modal instead of directly dispatching

    const packingStatus = ['Packing Initiated', "packing initiated"];
    if (!packingStatus.includes(salesOrderNo?.packing_status)) {
      showInfo("Payment is not received for this sales order. Please record payment first.");
      return;
    } else {
      setSelectedSalesOrderId(salesOrderNo?.sales_order_product_id || salesOrderNo?.sales_order_service_id || salesOrderNo?.id);
      setShowWarehouseModal(true);
    }
  };

  const handleWarehouseSubmit = async () => {
    if (!selectedWarehouse) {
      toast.error("Please select a warehouse");
      return;
    }

    try {
      await dispatch(
        fetchIssuePackingSalesOrderStatusUpdate({
          issuePackingPayload: {
            issue_packing: true,
            warehouse_id:
              selectedWarehouse.warehouse_id || selectedWarehouse.id,
          },
          id: selectedSalesOrderId,
        })
      ).unwrap();

      toast.success("Sales order issued for packing successfully");
      setShowWarehouseModal(false);
      setSelectedWarehouse(null);
      setSelectedSalesOrderId("");
      setReloadFlag((prev) => prev + 1);
    } catch (error: any) {
      console.error("Failed to issue for packing:", error);
      toast.error(error?.message || "Failed to issue for packing");
    }
  };

  const handleWarehouseModalClose = () => {
    setShowWarehouseModal(false);
    setSelectedWarehouse(null);
    setSelectedSalesOrderId("");
    setReloadFlag((prev) => prev + 1);
  };

  const handleStatusChange = async (
    salesOrderId: string,
    newStatus: string
  ) => {
    await dispatch(
      fetchSalesOrderStatusUpdate({ id: salesOrderId, status: newStatus })
    );
  };

  // Helper function to get status color
  const getStatusColor = (status: string): "default" | "primary" | "success" | "warning" | "error" | "info" => {
    const statusLower = (status || "").toLowerCase();
    if (statusLower.includes("in progress") || statusLower.includes("so created")) {
      return "info";
    } else if (statusLower.includes("completed") || statusLower.includes("delivered") || statusLower.includes("closed")) {
      return "success";
    } else if (statusLower.includes("pending") || statusLower.includes("on hold")) {
      return "warning";
    } else if (statusLower.includes("cancelled") || statusLower.includes("rejected")) {
      return "error";
    }
    return "default";
  };

  // Helper function to get packing status color
  const getPackingStatusColor = (status: string): "default" | "primary" | "success" | "warning" | "error" | "info" => {
    const statusLower = (status || "").toLowerCase();
    if (statusLower.includes("packing initiated")) {
      return "success";
    } else if (statusLower.includes("pending issue") || statusLower.includes("pending")) {
      return "warning";
    } else if (statusLower.includes("delivered") || statusLower.includes("closed")) {
      return "success";
    } else if (statusLower.includes("on hold")) {
      return "error";
    } else if (statusLower.includes("draft")) {
      return "default";
    }
    return "default";
  };

  const handleGeneratePI = async (salesOrderNo: any) => {
    const result = await showConfirm(
      "Are you sure you want to generate PI for this sales order?",
      "Generate PI",
      "Yes, Generate",
      "Cancel"
    );

    if (result.isConfirmed) {
      dispatch(handleProductGeneratePISalesOrder(salesOrderNo?.sales_order_product_id || salesOrderNo?.sales_order_service_id || salesOrderNo?.id))
        .unwrap()
        .then((res: any) => {
          if (res) {
            toast.success("PI generated successfully");
            // Trigger refresh by incrementing reloadFlag
            setReloadFlag(prev => prev + 1);
          }
        })
        .catch((err: any) => {
          toast.error(err?.message || "Failed to generate PI");
        });
    }
  };

  const getColumns = () => {
    const commonColumns = [
      // {
      //   header: "Sr. No.",
      //   accessorKey: "sr_no",
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   cell: ({ row, table }: { row: any; table: any }) =>
      //     table.getState().pagination.pageIndex *
      //       table.getState().pagination.pageSize +
      //     row.index +
      //     1,
      // },
      {
        header: "Sales Order No.",
        accessorKey: "sales_order_number",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "dropdown" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.PRODUCT.FILTER_DROPDOWN(
          "sales_order_number"
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) =>
          row.original.sales_order_number || "-",
      },
      {
        header: "SO Date",
        accessorKey: "sales_order_date",
        enableColumnFilter: false,
        enableSorting: true,
        filterType: "date" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.PRODUCT.FILTER_DROPDOWN(
          "sales_order_date"
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => (
          <FormattedDate date={row.original.sales_order_date} />
        ),
      },

      {
        header: "Quotation Reference",
        accessorKey: "quotation_number",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "dropdown" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.PRODUCT.FILTER_DROPDOWN(
          "quotation_number"
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => row.original.quotation_number || "-",
      },

      {
        header: "Customer Name",
        accessorKey: "company_name",
        enableColumnFilter: true,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.PRODUCT.FILTER_DROPDOWN(
          "company_name"
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) =>
          row.original.customer_details?.company_name || "-",
      },

      {
        header: "Agent",
        accessorKey: "agent_name",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.PRODUCT.FILTER_DROPDOWN(
          "agent_name"
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => row.original.agent_name || "-",
      },

      {
        header: "Grand Total",
        accessorKey: "grand_total_amount",
        enableColumnFilter: false,
        enableSorting: true,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.PRODUCT.FILTER_DROPDOWN(
          "grand_total_amount"
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => {
          const val = row.original.grand_total_amount;
          const sym = row.original.currency_symbol || "₹";
          return val != null && val !== "" ? `${sym} ${formatIndianAmount(val)}` : "-";
        },
      },
      {
        header: "Status",
        accessorKey: "sales_order_status",
        id: "sales_order_status",
        enableColumnFilter: true,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.PRODUCT.FILTER_DROPDOWN(
          "sales_order_status"
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => {
          const status = row.original.sales_order_status || "-";
          return <StatusChip status={status} />;
        },
      },
      {
        header: "Packing",
        accessorKey: "packing_status",
        id: "packing_status",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }: { row: any }) => {
          const status = row.original.packing_status || "-";
          return <StatusChip status={status} />;
        },
      },
      {
        header: "Dispatch Status",
        accessorKey: "dispatch_status",
        id: "dispatch_status",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }: { row: any }) => {
          const status = row.original.dispatch_status || "-";
          return <StatusChip status={status} />;
        },
      },
      {
        header: "Assigned To",
        accessorKey: "assigned_members",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.PRODUCT.FILTER_DROPDOWN("assigned_members")}&stage=draft`,

        cell: ({ row }: { row: any }) => {
          const members = row.original?.assigned_members || [];

          if (!members.length) return "-";

          const names = members.map(
            (m: any) =>
              `${m.first_name || ""} ${m.last_name || ""}`.trim() || m.username
          );

          const visible = names.slice(0, 4);
          const remaining = names.length - visible.length;

          return (
            <Tooltip
              arrow
              placement="top"
              title={names.join("\n")}
              componentsProps={{
                tooltip: {
                  sx: {
                    whiteSpace: "pre-line",
                    maxWidth: 250,
                    fontSize: "13px",
                  },
                },
              }}
            >
              <div style={{ cursor: "pointer", lineHeight: 1.4 }}>
                {visible.map((name: string, index: number) => (
                  <div key={index}>{name}</div>
                ))}

                {remaining > 0 && (
                  <div style={{ fontSize: "12px", color: "#6c757d" }}>
                    +{remaining} more
                  </div>
                )}
              </div>
            </Tooltip>
          );
        },
      },
      {
        header: "PO Date",
        accessorKey: "customer_po_date",
        id: "customer_po_date",
        enableColumnFilter: true,
        enableSorting: false,
        filterType: "date" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.PRODUCT.FILTER_DROPDOWN(
          "customer_po_date"
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => (
          <FormattedDate date={row.original.customer_details?.customer_po_date} />
        ),
      },
      {
        header: "Last Followup Date",
        accessorKey: "last_followup_date",
        id: "last_followup_date",
        enableColumnFilter: true,
        enableSorting: false,
        filterType: "date" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.PRODUCT.FILTER_DROPDOWN(
          "last_followup_date"
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => {
          // Get follow-up date from sales_order_follow_ups array
          const followUps = row.original.sales_order_follow_ups || [];
          const lastFollowUp =
            followUps.length > 0 ? followUps[followUps.length - 1] : null;
          const followUpDate = lastFollowUp
            ? lastFollowUp.follow_up_date
            : row.original.last_followup_date;
          return <FormattedDate date={followUpDate} />;
        },
      },

      {
        header: "Followup Remark",
        accessorKey: "followup_remark",
        id: "followup_remark",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "date" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.PRODUCT.FILTER_DROPDOWN(
          "followup_remark"
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => {
          // Get follow-up remarks from sales_order_follow_ups array
          const followUps = row.original.sales_order_follow_ups || [];
          const lastFollowUp =
            followUps.length > 0 ? followUps[followUps.length - 1] : null;
          const followUpRemark = lastFollowUp
            ? lastFollowUp.follow_up_remarks
            : null;
          // Strip HTML tags from the remark
          const cleanRemark = stripHtmlTags(followUpRemark);
          return (
            <div
              style={{
                whiteSpace: "normal",
                wordWrap: "break-word",
                minWidth: "150px",
              }}
            >
              {cleanRemark}
            </div>
          );
        },
      },
      {
        header: "Tags",
        accessorKey: "tags",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }: { row: any }) => {
          const tags: string[] = row.original.tags || [];
          if (!tags.length) return "-";

          const maxVisible = 3;
          const visible = tags.slice(0, maxVisible);
          const remaining = tags.length - visible.length;
          const tooltipText = tags.join(", ");

          return (
            <Tooltip
              arrow
              placement="top"
              title={tooltipText}
              componentsProps={{
                tooltip: {
                  sx: {
                    maxWidth: 300,
                    fontSize: "13px",
                    whiteSpace: "normal",
                  },
                },
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "4px",
                  minWidth: "150px",
                  cursor: "pointer",
                }}
              >
                {visible.map((tag: string) => (
                  <Chip key={tag}>{tag}</Chip>
                ))}
                {remaining > 0 && <Chip>+{remaining} more</Chip>}
              </div>
            </Tooltip>
          );
        },
      },
      {
        header: "Next Followup Date",
        accessorKey: "next_followup_date",
        id: "next_followup_date",
        enableColumnFilter: true,
        enableSorting: false,
        filterType: "date" as const,
        filterFetchUrl: `${API_ENDPOINT.SALES_ORDER.PRODUCT.FILTER_DROPDOWN(
          "next_followup_date"
        )}&stage=orders_log`,
        cell: ({ row }: { row: any }) => {
          // Get next follow-up date from sales_order_follow_ups array
          const followUps = row.original.sales_order_follow_ups || [];
          const lastFollowUp =
            followUps.length > 0 ? followUps[followUps.length - 1] : null;
          const nextFollowUpDate = lastFollowUp
            ? lastFollowUp.next_follow_up_date
            : row.original.next_followup_date;
          return <FormattedDate date={nextFollowUpDate} />;
        },
      },
      {
        header: "Notes",
        accessorKey: "notes",
        enableColumnFilter: false,
        enableSorting: false,
        minSize: 200,
        size: 200,
        cell: ({ row }: { row: any }) => (
          <div
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              maxWidth: "200px",
              minWidth: "200px",
            }}
          >
            {row.original.notes || "-"}
          </div>
        ),
        // filterType: "dropdown" as const,
        // filterFetchUrl: `/sales_order/${activeType}/dynamic_dropdown/notes?stage=orders_log`,
      },
      {
        header: "Created By/Date",
        accessorKey: "created_at",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => {
          const createdByUser = row.original.created_by_user;
          const userName = createdByUser
            ? createdByUser.username || "-"
            : "-";
          return (
            <NameWithDate name={userName} date={row.original.created_at} />
          );
        },
      },
      {
        header: "Updated By/Date",
        accessorKey: "updated_at",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => {
          const updatedByUser = row.original.updated_by_user;
          const userName = updatedByUser
            ? updatedByUser.username || "-"
            : "-";
          return (
            <NameWithDate name={userName} date={row.original.updated_at} />
          );
        },
      },
    ];

    const actionColumn = {
      header: "Action",
      enableColumnFilter: false,
      enableSorting: false,
      cell: ({ row }: { row: any }) => {
        const sales_order =
          row.original ||
          row.original.sales_order_service_id ||
          row.original.id;
        // console.log("sales_order in line 317", sales_order);
        // console.log("row.original in line 318", row.original);
        // Check status conditions
        // console.log("row.original.pi_generated in line 642", row.original.pi_generated)
        // console.log("row.original.issue_for_packing in line 643", row.original.issue_for_packing)
        const isIssueForPacking = row.original.packing_status === "Packing Initiated"  || row.original.packing_status === "packing initiated" && row.original.pi_generated
        // console.log("isIssueForPacking in line 643", isIssueForPacking)
        const salesOrderStatus = row.original.sales_order_status;
        const canEdit = salesOrderStatus === "So Created";
        const canInitiatePacking = row.original.packing_status === "pending issue";
        // console.log("canEdit in line 476", canEdit)
        const hasQuotationId = !!row.original.quotation_product_id;
        const data = row.original;


        const handleDownloadAcknowledgementPdf = async (
          id: string,
        ) => {
          try {
            showLoading("Downloading PDF...");
            await dispatch(
              handleProductDownloadAcknowledgementSalesOrder({ 
                id, 
                salesOrderNumber: data.sales_order_number || data.sales_order_product_id 
              })
            ).unwrap();
            hideLoading();
            showSuccess("PDF downloaded successfully");
          } catch (err: any) {
            hideLoading();
            showError(err?.message || "Failed to download PDF");
          }
        };

        const handleDownloadPdf = async (
          id: string,
          type: "pi" | "acknowledgement",
          salesOrderNumber: string
        ) => {
          // Show confirmation for Generate PI
          if (type === "pi") {
            const result = await showConfirm(
              "Are you sure you want to generate PI for this sales order?",
              "Generate PI",
              "Yes, Generate",
              "Cancel"
            );

            if (!result.isConfirmed) {
              return;
            }
          }

          try {
            showLoading("Downloading PDF...");
            await dispatch(
              handleProductGeneratePISalesOrder(id )
            ).unwrap();
       
         

            // Dispatch handleProductGeneratePISalesOrder after successful download
            if (type === "pi") {
              const salesOrderId = data?.sales_order_product_id || data?.sales_order_service_id || data?.id;
              if (salesOrderId) {
                try {
                  await dispatch(downloadSalesOrderPdf({id: salesOrderId, type: "pi", salesOrderNumber: data.sales_order_number || data.sales_order_product_id})).unwrap();
                  // Trigger refresh by incrementing reloadFlag
                  hideLoading();
                  showSuccess("PDF downloaded successfully");
                  setReloadFlag(prev => prev + 1);
                } catch (piError: any) {
                  console.error("Error generating PI:", piError);
                  // Don't show error to user as PDF was already downloaded successfully
                }
              }
            }
          } catch (err: any) {
            hideLoading();
            console.error("Error downloading PDF:", err);
            showError(err?.message || "Failed to download PDF");
          }
        };

        const actions = [
          ...(canView ? [{
            label: "View",
            permission: canView,
            icon: <VisibilityIcon fontSize="small" color="info" />,
            onClick: () => handleView(sales_order),
          }] : []),
          // Only show Edit if sales_order_status is "So Created" and user has Update permission
          ...(canEdit  && canUpdate
            ? [
              {
                label: "Edit",
                permission: canUpdate,
                icon: <EditIcon fontSize="small" color="primary" />,
                onClick: () => handleEdit(sales_order),
              },
            ]
            : []),
          {
            label: "Follow up",
            permission: canUpdate,
            icon: <PersonAddIcon fontSize="small" color="success" />,
            onClick: () => {
              setSelectedFollowUpItem(data);
              setShowFollowUpModal(true);
            },
          },
          ...(canView ? [{
            label: "Generate PI",
            permission: canView,
            icon: <InsertDriveFileIcon fontSize="small" color="primary" />,
            onClick: async () => {
              handleDownloadPdf(sales_order.sales_order_product_id, "pi", data.sales_order_number);
            },
          }] : []),

          ...(canView ? [{
            label: "Download Order Acknowledgement",
            permission: canView,
            icon: <InsertDriveFileIcon fontSize="small" color="primary" />,
            onClick: async () => {
              handleDownloadAcknowledgementPdf(
                sales_order.sales_order_product_id,
             
              );
            },
          }] : []),
          // Only show Issue Packing if not already issued for packing
          ...(isIssueForPacking
            ? 
         [
              {
                label: "Issue Packing",
                permission: canUpdate,
                icon: <DescriptionIcon fontSize="small" color="warning" />,
                onClick: () => handleIssuePacking(sales_order),
              },
            ] : []),
          // Show Revert if quotation_product_id exists, otherwise show Delete (only if user has Delete permission)
          ...(canEdit && canInitiatePacking && canUpdate ? [{
            label: hasQuotationId ? "Revert" : "Delete",
            icon: hasQuotationId ? <UndoIcon fontSize="small" color="warning" /> : <DeleteOutlineIcon fontSize="small" color="error" />,
            onClick: () => handleRevert(sales_order),
            className: "text-danger",
          }] : []),
        ];

        // return <ActionDropdown actions={actions} />;
        return <DynamicMenuItem row={row.original} menuItems={actions} />;
      },
    };
    return [...commonColumns, actionColumn];
  };

  return (
    <>
      <MasterListPage
        title={`Sales ${title}`}
        addButtonLabel={addButtonLabel}
        addRoute={addRoute}
        fetchThunk={"fetchSalesOrders"}
        exportThunk={"exportSalesOrdersCSV"}
        columns={getColumns()}
        statusToggleUrl={`/sales-order/product`}
        activeTab={activeTab}
        activeType={"product"}
        reloadFlag={reloadFlag}
      />

      {/* Warehouse Selection Modal */}
      <Dialog
        open={showWarehouseModal}
        onClose={handleWarehouseModalClose}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(4px)",
          },
        }}
        PaperProps={{
          sx: {
            borderRadius: "8px",
            overflow: "hidden",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
          },
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 3,
            fontWeight: 600,
            fontSize: "1.1rem",
            fontFamily: "'Poppins', sans-serif",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
    
            borderBottom: "none",
          }}
        >
          Select Warehouse for Issue Packing
          <IconButton
            aria-label="close"
            onClick={handleWarehouseModalClose}
            sx={{
              color: "#ffffff",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers={false}
          sx={{
            p: 3,
            // backgroundColor: "#f5f7fa",
            fontFamily: "'Poppins', sans-serif",
          }}
        >
          <Box>
            <Form.Group className="mb-0">
              <Typography
                component="label"
                htmlFor="warehouse-issue-packing-autocomplete"
                sx={{
                  display: "block",
                  mb: 1,
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  color: "#212529",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                Warehouse{" "}
                <Box component="span" sx={{ color: "#dc3545" }}>
                  *
                </Box>
              </Typography>
              <Autocomplete
                id="warehouse-issue-packing-autocomplete"
                options={warehouseOptions}
                getOptionLabel={(option: any) =>
                  option?.warehouse_name || option?.name || ""
                }
                {...autocompleteDropdownStyles}
                renderOption={(props, option) =>
                  autocompleteDropdownStyles.renderOption(
                    props,
                    option,
                    (option: any) =>
                      option?.warehouse_name || option?.name || ""
                  )
                }
                value={selectedWarehouse}
                onChange={(_, newValue) => {
                  setSelectedWarehouse(newValue);
                }}
                loading={loadingWarehouses}
                renderInput={(params) => (
                  <BootstrapTextField
                    {...params}
                    placeholder="Select Warehouse"
                    size="small"
                    error={!selectedWarehouse}
                    helperText={
                      !selectedWarehouse ? "Please select a warehouse" : ""
                    }
                    sx={autocompleteDropdownStyles.inputSx}
                  />
                )}
                ListboxProps={{
                  sx: {
                    ...autocompleteDropdownStyles.ListboxProps.sx,
                    "& .MuiAutocomplete-option[aria-selected='true']": {
                      backgroundColor: `${MecordColors.ThemeBGColor} !important`,
                      color: "#fff !important",
                    },
                  },
                }}
                isOptionEqualToValue={(option, value) => {
                  const optionId = option?.warehouse_id || option?.id;
                  const valueId = value?.warehouse_id || value?.id;
                  return optionId !== undefined && optionId !== null && optionId === valueId;
                }}
              />
            </Form.Group>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            p: 2,
            pt: 0,
            pb: 3,
            px: 3,
            gap: 1.5,
            justifyContent: "flex-end",
            // backgroundColor: "#f5f7fa",
            fontFamily: "'Poppins', sans-serif",
          }}
        >
          <MuiButton
            variant="outlined"
            onClick={handleWarehouseModalClose}
            sx={{
              textTransform: "none",
              fontFamily: "'Poppins', sans-serif",
              fontSize: "0.875rem",
              fontWeight: 500,
              borderColor: MecordColors.ActiveText,
              color: MecordColors.ActiveText,
              backgroundColor: "#fff",
              px: 2.5,
              "&:hover": {
                borderColor: MecordColors.ActiveText,
                backgroundColor: MecordColors.LightThemeBGColor,
              },
            }}
          >
            Cancel
          </MuiButton>
          <MuiButton
            variant="contained"
            onClick={handleWarehouseSubmit}
            disabled={!selectedWarehouse}
            sx={{
              textTransform: "none",
              fontFamily: "'Poppins', sans-serif",
              fontSize: "0.875rem",
              fontWeight: 500,
              backgroundColor: MecordColors.ThemeBGColor,
              boxShadow: "none",
              px: 2.5,
              "&:hover": {
                boxShadow: "none",
                backgroundColor: "#891A1C",
              },
              "&.Mui-disabled": {
                backgroundColor: "rgba(0, 0, 0, 0.12)",
                color: "rgba(0, 0, 0, 0.26)",
              },
            }}
          >
            Issue for Packing
          </MuiButton>
        </DialogActions>
      </Dialog>

      {/* Close follow-up modal and refresh list */}
      {/* (refresh on close, not only on save) */}
      {/*
        Keeping the handler inline here avoids needing to thread extra state.
      */}

      {/* Follow Up Modal */}
      <FollowUpPopUp
        open={showFollowUpModal}
        onClose={() => {
          setShowFollowUpModal(false);
          setReloadFlag((prev) => prev + 1);
        }}
        title="Follow-up and Activities"
      >
        {selectedFollowUpItem && (
          <FollowupModel
            data={selectedFollowUpItem}
            activeType={SALES_ORDER_TYPE?.PRODUCT}
            category={SALES_ORDER_CATEGORY?.OTHERS}
            onClose={() => {
              setShowFollowUpModal(false);
              setReloadFlag((prev) => prev + 1);
            }}
            onSuccess={() => {
              // Trigger refresh by incrementing reloadFlag
              setReloadFlag((prev) => prev + 1);
            }}
          />
        )}
      </FollowUpPopUp>
    </>
  );
};

export default SalesOrderLog;
